import React from 'react';
import {
  Box, Typography, Button, TextField, IconButton, List,
  MenuItem, FormControl, InputLabel, Select, Divider, Chip,
  Tabs, Tab, Switch, Slider, ToggleButton, ToggleButtonGroup,
  CircularProgress, FormControlLabel, Checkbox, Dialog,
  DialogTitle, DialogContent, DialogActions, Paper,
  Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import {
  Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon,
  CallSplit as CallSplitIcon, Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon, Check as CheckMarkIcon,
  Clear as CloseMarkIcon, Image as ImageIcon, TextFields as TextIcon,
  Title as TitleIcon, VideoLibrary as VideoIcon,
  SmartButton as ButtonIcon, CloudUpload as UploadIcon,
  FormatListBulleted as ListIcon, Star as StarIcon,
  Info as InfoIcon, Warning as WarningIcon, Verified as VerifiedIcon,
  ShoppingCart as ShoppingCartIcon, FileCopy as DuplicateIcon,
  ExpandMore as ExpandMoreIcon, ViewModule as TemplateIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { getPreset, getPresetFontFamilies } from '../../../../textStyle.js';
import { getSuggestedTextColors } from '../../../../utils/offerColorUtils';
import { ELEMENT_TYPES, TEMPLATE_TYPE_OPTIONS } from '../../../../utils/offerElementTypes';
import { LAYOUT_CONFIGS } from '../../../../utils/offerLayoutConfigs';
import { LAYOUT_TYPES } from '../../../../utils/offerElementTypes';
import S3FileUpload from '../../../S3FileUpload';
import SimplePresetSelector from '../../../SimplePresetSelector';
import ButtonPresetSelector from '../../../ButtonPresetSelector';
import ComparisonTablePresetSelector from '../../../ComparisonTablePresetSelector';
import {
  BRANDS_EDITOR_RIGHT_PANEL_WIDTH, BRANDS_EDITOR_SAVED_COL_WIDTH,
  BRANDS_PAGE_MAX_HEIGHT, BRANDS_REF_DEVICE_WIDTH, BRANDS_REF_DEVICE_HEIGHT,
  SETUPS_REF_DEVICE_WIDTH, SETUPS_REF_DEVICE_HEIGHT,
} from '../../../../utils/offerDeviceConstants';
import { useOfferBuilder } from '../../OfferBuilderContext';

const AddElementTab = () => {
  const {
      isMobile, isBrandsPage, templatesOnly, customElementsOnly,
      paginationEnabled, isEditingMode, forceRender,
      selectedElement, selectedElementContext, selectedSubElement,
      setSelectedElement, setSelectedElementContext, setSelectedSubElement,
      tabValue, setTabValue, rightPanelOpen, setRightPanelOpen,
      elements, pages, currentPageIndex, pageSettings,
      updateElement, addElement, moveToNewPage,
      handleImageUpload, handleThumbnailUpload, handleMediaUploadForElement,
      contentTabTempValue, setContentTabTempValue,
      buttonContentTabTempValue, setButtonContentTabTempValue,
      buttonUrlTabTempValue, setButtonUrlTabTempValue,
      saveContentTabEdit, cancelContentTabEdit, handleContentTabKeyPress,
      saveButtonContentTabEdit, cancelButtonContentTabEdit, handleButtonContentTabKeyPress,
      saveButtonUrlTabEdit, cancelButtonUrlTabEdit, handleButtonUrlTabKeyPress,
      listItemTextValues, setListItemTextValues,
      localRatingText, setLocalRatingText,
      renameElementId, setRenameElementId, renameElementValue, setRenameElementValue,
      getCurrentFontFamily, getInlineBackgroundColors, getInlineTextColors,
      savedOfferElements, filteredSavedElements, setFilteredSavedElements,
      loadSavedOfferElements, loadSavedElement, deleteSavedElement, editSavedElement,
      selectedBrand, selectedOffer, brands, offers, setSelectedBrand, setSelectedOffer, loadOffersForBrand,
      setShowStatusAlert, setStatusMessage, setStatusTitle,
      showConfirmDialog, setShowConfirmDialog, confirmDialogTitle, confirmDialogMessage,
      confirmAction, setConfirmAction, setConfirmDialogTitle, setConfirmDialogMessage,
      showRenameDialog, setShowRenameDialog,
      showLayoutSelector, setShowLayoutSelector, targetZone, setTargetZone,
      showSaveElementDialog, setShowSaveElementDialog, isUpdatingElement, setIsUpdatingElement,
      currentElementName, setCurrentElementName, selectedSavedElementId, setSelectedSavedElementId,
      setSaveType, saveType, saveCurrentElement,
      showLoadTemplateAlert, setShowLoadTemplateAlert, loadTemplateError,
      showReplaceConfirm, setShowReplaceConfirm, pendingTemplateData, loadReplaceTemplate,
      showStatusAlert, statusMessage, statusTitle,
      showPromptDialog, setShowPromptDialog, promptDialogTitle, promptDialogMessage,
      promptDialogValue, setPromptDialogValue, promptAction, setPromptAction,
      showSaveDialog, setShowSaveDialog, saveTemplate,
      showTemplatesList, setShowTemplatesList, templates, loadTemplate, deleteTemplate,
      setOffers, setForceRender,
      imageUploading, uploadingElementId, savedTemplates, setSavedTemplates,
      preBuiltTemplates, loadPreBuiltTemplate, currentTemplateId, setCurrentTemplateId,
      templateName, setTemplateName, templateType, setTemplateType,
      templateSubtype, setTemplateSubtype, groupTemplatesByType, addLayout,
      showBrandOfferAlert, setShowBrandOfferAlert, renameSavedElement,
      setCurrentPageIndex, setElements, setNextPageId, setPageSettings,
      setPages, setPaginationEnabled, setPendingTemplateData,
    } = useOfferBuilder();

  return (
    <Box>
      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => addElement(ELEMENT_TYPES.HEADING)}
            startIcon={<TitleIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#1976d2',
              borderColor: '#1976d2',
              fontSize: '0.65rem',
              padding: '4px 2px',
              minWidth: 0,
              flexDirection: 'column',
              '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
            }}
          >
            ADD TITLE
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => addElement(ELEMENT_TYPES.TEXT)}
            startIcon={<TextIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#1976d2',
              borderColor: '#1976d2',
              fontSize: '0.65rem',
              padding: '4px 2px',
              minWidth: 0,
              flexDirection: 'column',
              '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
            }}
          >
            ADD TEXT
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => addElement(ELEMENT_TYPES.MEDIA)}
            startIcon={<VideoIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#1976d2',
              borderColor: '#1976d2',
              fontSize: '0.65rem',
              padding: '4px 2px',
              minWidth: 0,
              flexDirection: 'column',
              '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
            }}
          >
            ADD MEDIA
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => addElement(ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY)}
            startIcon={<VideoIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#1976d2',
              borderColor: '#1976d2',
              fontSize: '0.65rem',
              padding: '4px 2px',
              minWidth: 0,
              flexDirection: 'column',
              '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
            }}
          >
            Video w/ overlay button
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => addElement(ELEMENT_TYPES.BUTTON)}
            startIcon={<ShoppingCartIcon />}
            sx={{
              textTransform: 'none',
              color: '#1976d2',
              borderColor: '#1976d2',
              fontSize: '0.65rem',
              padding: '4px 2px',
              minWidth: 0,
              flexDirection: 'column',
              '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
            }}
          >
            insert button
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => addElement(ELEMENT_TYPES.CUSTOM_LIST)}
            startIcon={<ListIcon />}
            sx={{
              textTransform: 'none',
              color: '#1976d2',
              borderColor: '#1976d2',
              fontSize: '0.65rem',
              padding: '4px 2px',
              minWidth: 0,
              flexDirection: 'column',
              '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
            }}
          >
            insert bullets
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddElementTab;
